<template>
    <BasicModalWindow
        ref="modal"
        class="links-editor"
        title="editor.link_title"
    >
        <template #body>
            <form>
                <fieldset>
                    <div class="control-group link-text" v-if="link_data.nodes === 1">
                        <div class="control">
                            <label
                              for="text"
                            >
                              {{Language.say('editor.text_link')}}
                            </label>
                            <input
                              id="text"
                              type="text"
                              v-model="link_data.text"
                              :placeholder="Language.say('editor.text_placeholder')">
                        </div>
                    </div>
                    <div class="control-group link-url">
                        <div class="control">
                            <label for="url">{{Language.say('editor.protocol')}}</label>
                            <span class="select-wrapper">
                                <select v-model="link_protocol">
                                    <option v-for="protocol in protocols" :key="protocol"
                                      :value="protocol">{{protocol}}</option>
                                </select>
                            </span>
                        </div>
                        <div class="control">
                            <label for="url">{{Language.say('editor.url')}}</label>
                            <input
                              @keyup="onLinkHrefChange()"
                              id="url"
                              type="text"
                              v-model="link_data.href"
                              :placeholder="Language.say('editor.url')"
                            >
                        </div>
                    </div>
                </fieldset>
            </form>
        </template>

        <template #footer>
          <ActionButton
              text="global.actions.cancel"
              @click="onSubmitCancel()"
          />
          <ActionButton v-if="action_type === 'remove'"
              @click="onRemoveLink()"
              class='main-action push-right'
              text="editor.actions.remove_link"
              :disabled="action_disabled"
          />

          <ActionButton v-if="action_type === 'add'"
              @click="onSubmitLink()"
              class='main-action push-right'
              text="editor.actions.add_link"
              :disabled="action_disabled"
          />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import { ref, defineProps, onBeforeMount } from 'vue';
  import BasicModalWindow                    from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                        from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language                            from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    html_editor : {},
    click_event : {},
  })

  const protocols = [
    'https://',
    'http://',
    'mailto:',
    'tel:',
  ];

  const default_protocol = 'https://';
  const modal            = ref();
  const link_data        = ref('');
  const link_protocol    = ref('');
  const action_type      = ref('add');
  const action_disabled  = ref(true);

  onBeforeMount(() => {
    setLinkData(props.html_editor.getSelectedLinkData(props.click_event));
    replaceLinkProtocol();
    setLinkProtocol(default_protocol);
    setActionType();
  })

  const onSubmitLink = () => {
    setEditorSelection();
    setLinkDataHref(link_protocol.value + link_data.value.href)
    props.html_editor.insertLink(link_data.value, props.click_event);
    props.html_editor.squire.moveCursorToEnd(props.click_event.target);
    close();
  }

  const onRemoveLink = () => {
    props.html_editor.removeLink(link_data.value);
    props.html_editor.squire.moveCursorToEnd(props.click_event.target);
    close();
  }

  const onSubmitCancel = () => {
    close();
  }

  const onLinkHrefChange = () => {
    replaceLinkProtocol();
    setActionType();
  }

  const setEditorSelection = () => {
    if (link_data.nodes === 1 || (props.click_event.target && props.click_event.target.nodeName !== 'IMG')) {
      return;
    }

    props.html_editor.setSelection(props.click_event.target);
  }

  const replaceLinkProtocol = () => {
    for (let i = 0; i < protocols.length; i++) {
      if (link_data.value.href.startsWith(protocols[i]) === false) {
        continue;
      }

      setLinkDataHref(link_data.value.href.replace(protocols[i], ''));
      setLinkProtocol(protocols[i]);
    }
  }

  const setLinkData = (value) => {
    link_data.value = value;
  }

  const setLinkProtocol = (value) => {
    link_protocol.value  = value;
  }

  const setLinkDataText = (value) => {
    link_data.value.text = value;
  }

  const setLinkDataHref = (value) => {
    link_data.value.href = value;
  }

  const setActionType = () => {
    action_disabled.value = false;

    if (!link_data.value.node_link && !link_data.value.href) {
      action_disabled.value = true;
      return;
    }

    if (link_data.value.node_link && !link_data.value.href) {
      action_type.value = 'remove';
      return;
    }

    action_type.value = 'add';
  }

  const close = () => {
    modal.value.close();
  }
</script>
